import React from 'react';
import {TabView} from '../../../components/tab/TabView';
import {DripEmailActiveTable, DripEmailCompletedTable} from './DripEmailTable';
import {SearchFilter} from '../../../components/filter/Filters';
import {useFilter} from '../../../controllers/useFilter';

export const DripEmailTabView = props => {
  const {route: {params} = {}} = props;
  const {onChangeFilter, searchValue} = useFilter({});
  let tabs = {
    active: {
      label: 'Active',
      view: <DripEmailActiveTable searchValue={searchValue} />,
    },
    completed: {
      label: 'Completed',
      view: <DripEmailCompletedTable searchValue={searchValue} />,
    },
  };

  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      actions={[
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
      ]}
    />
  );
};
